import { OfferRecipientTable } from './OfferRecipientTable'
import { OfferRecipients } from '../../../types/flyout'
import { FormikProps } from 'formik'
import { useStyles } from './OfferRecipientWithTable.styles'
import { NoteV2 } from '@labrav/react-components'
import { OfferRecipientV4 } from '../OfferRecipientV4/OfferRecipientV4'
import { Divider } from '@mui/material'

export const OfferRecipientWithTable = ({
  offerRecipients,
  formik,
  heading,
  keyName,
}: {
  offerRecipients: OfferRecipients[]
  formik: FormikProps<Record<string, unknown>>
  heading?: string
  keyName?: string
}) => {
  const { classes } = useStyles()
  return (
    <div className={classes.container}>
      <div className={classes.headingContainer}>
        <div className={classes.bold} data-testid="box-heading">
          {heading || 'Offer recipients'}
        </div>
      </div>
      <div className={classes.noteContainer}>
        <NoteV2 description="These recipients are pulled from Contacts linked to the opportunity." />
      </div>
      <div className={classes.offerRecipientTableContainer}>
        <OfferRecipientTable
          offerRecipients={offerRecipients}
          formik={formik}
          keyName={keyName || 'offerRecipients'}
        />
        <Divider />
      </div>
      <OfferRecipientV4
        formik={formik}
        customClassName={classes.offerRecipientV4Container}
        existingRecipientsEmails={offerRecipients.map(
          recipient => recipient.email
        )}
        keyName={keyName || 'offerRecipients'}
      />
    </div>
  )
}
